import { Injectable } from '@angular/core';
import { RequestorModel } from '../shopping-cart/requestor-model.model';
import {  HttpClient, HttpHeaders } from '@angular/common/http';
import { JsonRequestModel } from './json-request-model.model';
import { JsonPostModel } from './json-post-model.model';
import { ErrorService } from '../errors/error.service';
import { FilePostService } from './file-post.service';
import { EnvironmentService } from '../environment.service';

@Injectable()
export class ReqSubmitService {
  private readonly intakeUrl = '/dpwsvc/v1/ext/intake';

  constructor(
    private http: HttpClient, 
    private errorService: ErrorService, 
    private fileService: FilePostService,
    private environmentService: EnvironmentService) {}

 public submitRequest(requestor: RequestorModel): void {
    let caseId = '';
    const intakeRequests: JsonRequestModel[] =  new Array<JsonRequestModel>();
    const jsModel = new JsonPostModel(requestor);
    const documents = new Array<File>();

    requestor.contactRequests.forEach(element => {
      intakeRequests.push(new JsonRequestModel(element));

      if (element.doc) {
        documents.push(element.doc) ;
      }
      
      if (element.optDocs && element.optDocs.length > 0) {
        documents.push(...element.optDocs);
      }
    });

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    this.http.post<any>(this.environmentService.getServer() + this.intakeUrl, {
      intakeChangeRequests: intakeRequests,
      requestorEmail: jsModel.requestorEmail,
      requestorFaxNo: jsModel.requestorFaxNo,
      requestorFaxRegion: jsModel.requestorFaxRegion,
      requestorFullName: jsModel.requestorFullName,
      requestorPhoneNo: jsModel.requestorPhoneNo,
      requestorPhoneRegion: jsModel.requestorPhoneRegion,
      recaptchaToken: jsModel.recaptchaToken,
      signature: jsModel.signature,
      addpTdp: jsModel.addpTdp

    }).subscribe(
      result => {
        if (result && result.statusMessage !== 'SUCCESS') {
          this.errorService.processError(result);
          window.scrollTo(0, 0);
        }

        caseId = result.entity;
        this.fileService.loadAndSendFiles(documents, requestor.contactCapcha, caseId);
      },
      error => {
        this.errorService.processError(error);
        window.scrollTo(0, 0);
      }
    );
  }
}
